import type ViewState from '../store/schema/ViewState';
import { getSchedulingAssistantState } from '../selectors/getSchedulingAssistantState';

export default function getViewState(viewStateId: string): ViewState {
    return getSchedulingAssistantState(viewStateId).viewState;
}
